import React, { useReducer, useEffect, useRef } from "react";
import { Button, Grid, Modal, Icon, Popup, Dropdown } from "semantic-ui-react";
import {
  initialState,
  reducer,
  ACTION,
} from "../../../Reducer/InitialStateReducer";

import { server } from "../../../App";
import axios from "axios";

import moment from "moment";
import "moment/locale/fr";
import { toast } from "react-toastify";

import { Editor } from "@tinymce/tinymce-react";
import { useSelector, useDispatch } from "react-redux";
import { selectCounters, Certificat_Counter_Reducer } from "../../../features/counter/counterSlice";


function Medicaments(props) {
  const dispatchRedux = useDispatch();
  const CountersState = useSelector(selectCounters);
  const [state, dispatch] = useReducer(reducer, initialState);
  const {
    ID,
    syncData,
    userInformation,

    questionnaireData,
    consultationData,
    AuthState,
  } = props;

  moment.locale("fr");
  // let date_courrier = moment().format("DD/MM/YYYY")
  let date_courrier_Long = moment().format("dddd D MMMM YYYY");

  useEffect(() => {
    // getOneUser()
    dispatch({ type: ACTION.FETCH_SUCCESS2, payload: questionnaireData });
    dispatch({ type: ACTION.FETCH_SUCCESS, payload: consultationData });
  }, [state.open]);

  const writeToConsultation = async () => {
    let variable = date_courrier_Long ? `Le ${date_courrier_Long}` : "";

    let valueToPost = `Certificat fait ${variable}`;

    const ValuesToCreate = {
      fk_id_patientConsul: ID,
      created_by: AuthState.user_name,
      od: valueToPost,
      fk_id_examen: 1,
      observation: "-",
    };

    axios({
      method: "post",
      responseType: "json",
      url: `${server}Consultation`,
      data: ValuesToCreate,
      headers: {
        jwtoken: sessionStorage.token,
      },
    })
      .then((response) => {
        syncData(response.data);
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: ACTION.CREATE_ERROR });
      });
  };

  const editorRef = useRef(null);

  const onValueChanged = async () => {
    if (editorRef.current) {
      // console.log(editorRef.current.getContent());

      const ValuesToCreate = {
        fk_id_patientConsul: ID,
        description: editorRef.current.getContent(),
      };
      axios({
        method: "post",
        responseType: "json",
        url: `${server}Consultation/addcert`,
        data: ValuesToCreate,
        headers: {
          jwtoken: sessionStorage.token,
        },
      })
        .then((response) => {
          dispatchRedux(Certificat_Counter_Reducer(CountersState.Certificat_Counter + 1));
          writeToConsultation();
          toast.success("Success", {
            position: toast.POSITION.TOP_LEFT,
          });
          dispatch({ type: ACTION.CLOSE });
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: ACTION.CREATE_ERROR });
        });
    }
  };

  const certOptions = [
    {
      key: "empty",
      text: "",
      value: "",
    },
    {
      key: "1",
      text: "Certificat de présence",
      value: `
      <p style="text-align: justify;">
      Je soussigné <strong>${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</strong> certifie que <strong>${userInformation?.civilite} 
      ${userInformation?.nom} ${userInformation?.prenom}</strong> s'est présenté(e) ce jour à ma consultation.</p>
    <p>Certificat fait à la demande de l'intéressé (e) pour servir et valoir ce que de droit.</p>
    <p>NB : certificat délivré gratuitement.</p>
      
      <h4 style="text-align: right;">${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</h4>
      `,
    },
    {
      key: "2",
      text: "Accompagnement",
      value: `
      <p style="text-align: justify;">
      Je soussigné <strong>${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</strong> certifie que ............ a accompagné ce jour <strong>${userInformation?.civilite} 
      ${userInformation?.nom} ${userInformation?.prenom}</strong> au Centre d'Ophtalmologie Al-Badr.</p>
    <p>Certificat fait à la demande de l'intéressé (e) pour servir et valoir ce que de droit.</p>
    <p>NB : certificat délivré gratuitement.</p>
      <h4 style="text-align: right;">${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</h4>
      `,
    },
    {
      key: "3",
      text: "Arrêt de travail",
      value: `
      <p style="text-align: justify;">
      Je soussigné <strong>${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</strong>, certifie avoir examiné ce jour <strong>${userInformation?.civilite} 
      ${userInformation?.nom} ${userInformation?.prenom}</strong>. Son état oculaire nécessite un arrét de travail de quinze jours (...15...jours) à compter de ce jour sauf complications.</p>
      <p>Certificat fait à la demande de l'intéressé (e) pour servir et valoir ce que de droit.</p>
      <p>NB : certificat délivré gratuitement.</p>
      
      <h4 style="text-align: right;">${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</h4>
      `,
    },
    {
      key: "4",
      text: "Maladie chronique",
      value: `
      <p style="text-align: justify;">
      Je soussigné <strong>${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</strong>, certifie que <strong>${userInformation?.civilite} 
      ${userInformation?.nom} ${userInformation?.prenom}</strong> présente une maladie chronique (    ) nécessitant une surveillance et un traitement de longue durée.</p>
      <p>Certificat fait à la demande de l'intéressé (e) pour servir et valoir ce que de droit.</p>
      <p>NB : certificat délivré gratuitement.</p>
      
      <h4 style="text-align: right;">${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</h4>
      `,
    },
    {
      key: "7",
      text: "Acuité visuelle",
      value: `
      <p style="text-align: justify;">
      Je soussigné <strong>${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</strong> certifie avoir examiné ce jour <strong>${userInformation?.civilite} 
      ${userInformation?.nom} ${userInformation?.prenom}</strong>. Son acuité visuelle sans correction est de 10/10 des 2 yeux.</p>
    <p>Certificat fait à la demande de l'intéressé (e) pour servir et valoir ce que de droit.</p>
    <p>NB : certificat délivré gratuitement.</p>
      
      <h4 style="text-align: right;">${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</h4>
      `,
    },
    {
      key: "5",
      text: "Enfant dans le 1er rang",
      value: `
      <p style="text-align: justify;">
      Je soussigné <strong>${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</strong> avoir examiné l'enfant <strong>${userInformation?.civilite} 
      ${userInformation?.nom} ${userInformation?.prenom}</strong> qui présente une anomalie rétractive importante nécessitant de placer l'enfant dans les premiers rangs dans la classe pour ne aggraver l'handicap visuel existant.</p>
      <p>Certificat fait à la demande de l'intéressé (e) pour servir et valoir ce que de droit.</p>
      <p>NB : certificat délivré gratuitement.</p>
      
      <h4 style="text-align: right;">${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</h4>
      `,
    },
    {
      key: "6",
      text: "Certificat de guerison",
      value: `
      <p style="text-align: justify;">
      Je soussigné <strong>${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</strong> certifie que <strong>${userInformation?.civilite} 
      ${userInformation?.nom} ${userInformation?.prenom}</strong>, ne présente plus aucun symptôme oculaire en rapport avec sa récente affection.</p>
      <p>Certificat fait à la demande de l'intéressé (e) pour servir et valoir ce que de droit.</p>
      <p>NB : certificat délivré gratuitement.</p>
      
      <h4 style="text-align: right;">${AuthState.role === "admin" ? AuthState.user_name : userInformation.user_name}</h4>
      `,
    },
  ];

  let contentHtml5 = ` <h4 style="text-align: center;">
        ${userInformation?.civilite} 
        ${userInformation?.nom} ${userInformation?.prenom}
      </h4>
      `;
  // let contentHtml5 = ` <h4 style="text-align: center;">
  //       ${userInformation?.civilite}
  //       ${userInformation?.nom} ${userInformation?.prenom},

  //     </h4>

  //     <h4 style="text-align: center;">
  //     ${
  //       Math.round(userInformation?.AGEPATIENT) > 1
  //         ? `${Math.round(userInformation?.AGEPATIENT)} ans`
  //         : `${Math.round(userInformation?.AGEPATIENT * 12)} mois`
  //     }.
  //     </h4>

  //     `;

  let contentHtml4 = `<h4 style="text-align: center;">${date_courrier_Long}</h4>`;
  let dataToSeeFinal;
  if (state.MontureNewAVOptions) {
    dataToSeeFinal = contentHtml4 + contentHtml5 + state.MontureNewAVOptions;
  } else {
    dataToSeeFinal = contentHtml4 + contentHtml5;
  }

  let Contents = (
    <div>
      <Editor
        tinymceScriptSrc={process.env.PUBLIC_URL + "/tinymce/tinymce.min.js"}
        onInit={(evt, editor) => (editorRef.current = editor)}
        initialValue={dataToSeeFinal}
        init={{
          branding: false,
          height: "81.5vh",
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help ",
            "print",
          ],
          toolbar:
            "undo redo | formatselect | " +
            "bold italic underline print forecolor backcolor | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | ",
          content_style:
            "@page { size: A5;margin-top: 3.8cm; margin-bottom: 2.2cm; margin-left:0.25cm; margin-right:0.25cm; } body{font-size:16px} "
        }}
      />
    </div>
  );

  return (
    <>
      <Popup
        content="Certificat"
        trigger={
          <Button

            color="olive"
            onClick={() => dispatch({ type: ACTION.OPEN, size: "fullscreen" })}
          >
            <Icon
              color="black"
              name="file alternate outline"
              size="large"
              className="centerIcon"
            />
          </Button>
        }
      />

      <Modal
        // size={state.size}
        open={state.open}
        onClose={() => dispatch({ type: ACTION.CLOSE })}
      // className="lunettesModal2"
      >
        <Modal.Header className="center3columnheaders">
          <Dropdown
            className="fixSize"
            value={state.MontureNewAVOptions}
            selection
            options={certOptions}
            placeholder="Models certificats"
            onChange={(e, data) =>
              dispatch({
                type: ACTION.Fill_FORM_Montures_cadre,
                payload: data.value,
              })
            }
          />

          <Button
            floated="right"
            color="blue"
            onClick={() => dispatch({ type: ACTION.CLOSE })}
          >
            Retour <Icon className="leftSpace" name="reply" />
          </Button>
          <Button floated="right" positive onClick={onValueChanged}>
            Sauvegarder et retour
          </Button>
        </Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Column width={16}>{Contents}</Grid.Column>
          </Grid>
        </Modal.Content>
      </Modal>
    </>
  );
}

export default Medicaments;
